import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from "react-dom";
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'

import LoadingAlert from '../Alerts/LoadingAlert';
import Empty from '../utils/Empty';
import ErrorAlert from '../Alerts/ErrorAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import Swal from 'sweetalert2';
import { FaHistory } from 'react-icons/fa';
import { RenderIf } from '../utils/RenderIf';
import { MachinesFetchAPI } from '../../api/Machines';
import { CashTempPosFetchAPI } from '../../api/Paymentpost/OrderTemporalCash';
import { PrinterFetchAPI } from '../../api/Printer';
import { OrdersFetchAPI } from '../../api/Orders';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import { YappyFetchAPI } from '../../api/Paymentpost/Yappy';
import { generateToken } from '../../utils/GenerateToken';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import { normalizeApiError, showApiError } from '../../utils/ApiError';
import {
    buildKinposPartialAmount,
    findKinposPaymentMethodById,
    getKnownKinposCardNetworkPaymentMethodId,
    getPaymentIntegrationId,
    getPaymentMethodId,
    isKinposPaymentMethod,
    kinposPaymentBridge,
    resolveActualKinposPaymentMethod,
    toKinposPaymentRecord,
} from '../../utils/KinposBridge';
import ModalPhoneSaveYappy from './ModalPhoneSaveYappy';
import ModalPaymentManual from './ModalPaymentManual';
import ModalYappyQrPos from './ModalYappyQrPos';
import Cashierpost from '../cahsier/Cashierpost';

import loading from './img/loading.gif'
import empty_img from './img/empty_pays.png';
import checkimg from './img/check.png';
import cancel from './img/cancel.png'
import sadImg from './img/sad.png'
import PayScroller from './PaySheet/PayScroller';

const VOUCHER_SEPARATOR = "\r\n\r\n- - - - - - - - - - - - - - - - - - - -\r\n";

const safeJsonParse = (value, fallback = null) => {
    if (value == null || value === "" || value === "undefined") {
        return fallback;
    }

    try {
        return JSON.parse(value);
    } catch (err) {
        return fallback;
    }
}

const normalizeVoucherText = (voucherData) => {
    if (typeof voucherData === "string") {
        return voucherData;
    }

    if (voucherData && typeof voucherData === "object" && typeof voucherData.voucher === "string") {
        return voucherData.voucher;
    }

    return "";
}

const getStoredMixtoVoucher = () => {
    return normalizeVoucherText(safeJsonParse(localStorage.getItem('voucher_mixto'), ""));
}

const saveMixtoVoucher = (currentVoucher, nextVoucher) => {
    const currentText = normalizeVoucherText(currentVoucher);
    const nextText = normalizeVoucherText(nextVoucher);

    if (!nextText) {
        if (currentText) {
            localStorage.setItem('voucher_mixto', JSON.stringify({ voucher: currentText }));
        } else {
            localStorage.removeItem('voucher_mixto');
        }
        return { voucher: currentText };
    }

    const voucher = currentText ? `${currentText}${VOUCHER_SEPARATOR}${nextText}` : nextText;
    localStorage.setItem('voucher_mixto', JSON.stringify({ voucher }));
    return { voucher };
}



function ModalPaymentMixto({ showModalMixto, setShowModalMixto, paymentMethod, total, subtotal, discount, tax, orderNumber, formatDataOrder, registernewOrder, listPaymentReady,
    setlistPaymentReady, amountPaymentReady, setAmountPaymenReady, shoppingCart, amountPending, setAmountPending, change, setChange, yappy_transaction_id,
    setYappy_transaction_id, decimalReduction }) {
    const [paymentInfo, setPaymentInfo] = useState({ payment: "" })
    const [showModalAmount, setShowModalAmount] = useState(false)
    const [amountPayment, setAmountPayment] = useState(0)
    const [showModalProcess, setShowModalProcess] = useState(false);
    const [paymentApproval, setPaymentApproval] = useState({ status: 0, description: "Procesando pago" })
    const [tempMethodPayment, setTempMethodPayment] = useState(0)
    const [showModalPhone, setShowModalPhone] = useState(false);
    const [phoneClientYappy, setPhoneClientYappy] = useState("0");
    const [EMVStreamResponseMixto, setEMVStreamResponseMixto] = useState(0)
    //const [EMVStreamResponseMixto, setEMVStreamResponseMixto] = useState(0)
    //const [change, setChange] = useState(0);
    const [orderNumbeTemp, setOrderNumberTemp] = useState({ code: "", temp_id: "" })
    const [numberOrderMixto, setNumberOrderMixto] = useState("")
    const [showPaymentManual, setPaymentManual] = useState(false)
    const [kinposPaymentPending, setKinposPaymentPending] = useState(() => {
        const pendingPayment = kinposPaymentBridge.getPendingPayment();
        return pendingPayment?.mode === "mixed" && pendingPayment.state !== "awaiting_registration";
    })
    const kinposResultHandlerRef = useRef(null);

    //Yappy QR
    const [statePayment, setStatePayment] = useState(false);
    const [modalYappyQr, setModalYappyQr] = useState(false);
    const [dataYappy, setDataYappy] = useState({});
    const [dataHash, setDataHash] = useState("");
    const [statusRequestYappy, setStatusRequestYappy] = useState(false);

    let ventanaYappy = 0;
    let instervalCash = 0

    //cashier states
    const [modalShow, setModalShow] = useState(false);
    const [modalShowErrorRegisterOrder, setModalShowErrorRegisterOrder] = useState(false)
    const [detailOrder, setDetailOrder] = useState()
    const [amountOrder, setAmountOrder] = useState()

    //Functions to show and hide the modal cashier
    const handleCloseModal = () => setModalShow(false);
    const handleShowModal = () => setModalShow(true)



    //save info of payment
    const selectPayment = (e) => {
        if (e.target.checked == true) {
            let payment = JSON.parse(e.target.value)
            setPaymentInfo(payment)
        }
    }

    //next step phone number yappy
    const nextStepYappy = () => {
        setShowModalPhone(false)
        setShowModalProcess(true);

        //request c# yappy
        requestPyament(orderNumber);
        //createOrderCash("Yappy")
    }

    const statusCash = (status) => {
        if (status == 1) {//aprobed
            //function register payment

            let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
            let statusPaymentTurn = false;
            /*for (let i = 0; i < listPaymentReady.length; i++) {
                if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                    let newTotal = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                    listPaymentReady[i].total = newTotal.toFixed(2)
                    setlistPaymentReady(listPaymentReady)
                    statusPaymentTurn = true
                }
            }*/

            if (statusPaymentTurn == false) {
                localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }] }))
                setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }]);
            }

            console.log(newAmountReady);
            setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
            setAmountPaymenReady(newAmountReady)

            setTimeout(() => {
                setAmountPayment(0)
                setShowModalProcess(false);
                setPaymentApproval({ status: 0, description: "Procesando pago..." })

            }, 1500);


            handleCloseModal()
        } else if (status == 2) {//cancel
            setShowModalProcess(false);
            handleCloseModal()
        }
    }

    const showKinposFailure = (failure = {}) => {
        const isUncertain = failure.status === "uncertain";
        const title = isUncertain
            ? "Resultado pendiente de confirmacion"
            : failure.status === "declined"
                ? "Pago rechazado"
                : failure.status === "cancelled"
                    ? "Pago cancelado"
                    : "No se pudo procesar el pago";
        const defaultMessage = isUncertain
            ? "El resultado del pago aun no ha sido confirmado. Estamos verificando la transaccion antes de permitir otro intento."
            : failure.status === "declined"
                ? "KinPOS rechazo el pago. Puedes intentar nuevamente."
                : failure.status === "cancelled"
                    ? "El cobro fue cancelado y no se agrego al pago mixto."
                    : "No se pudo completar el cobro KinPOS/PAX.";
        const technicalDetail = [
            failure.request_id ? `Solicitud: ${failure.request_id}` : "",
            failure.code ? `Codigo: ${failure.code}` : "",
        ].filter(Boolean).join(" | ");

        ErrorAlert(
            failure.message || defaultMessage,
            title,
            failure.status === "cancelled" ? "info" : "warning",
            undefined,
            { detail: technicalDetail }
        );
    }

    const requestKinposPayment = async () => {
        if (kinposPaymentPending || kinposPaymentBridge.hasPendingPayment()) {
            showKinposFailure({ status: "uncertain" });
            return;
        }

        if (!kinposPaymentBridge.isAvailable()) {
            setShowModalProcess(false);
            ErrorAlert(
                "La integracion KinPOS/PAX no esta disponible en este dispositivo.",
                "Terminal no disponible",
                "warning"
            );
            return;
        }

        setKinposPaymentPending(true);
        setTempMethodPayment(0);
        setPaymentApproval({ status: 0, description: "Procesando pago en el terminal KinPOS/PAX..." });
        setShowModalProcess(true);
        setShowModalAmount(false);

        try {
            await kinposPaymentBridge.charge({
                payment: paymentInfo,
                amount: buildKinposPartialAmount(amountPayment),
                orderReference: orderNumber,
                mode: "mixed",
            });
        } catch (error) {
            setPaymentApproval({ status: 2, description: error.message || "Error de comunicacion con KinPOS" });
            setShowModalProcess(false);
            showKinposFailure(error);
            setKinposPaymentPending(false);
        }
    }

    //function process payment of the order
    const processPayment = async () => {

        if (parseFloat(amountPayment) > parseFloat(amountPending).toFixed(2)) {
            console.log("Ingresado: " + parseFloat(amountPayment));
            console.log("Pendiente: " + parseFloat(amountPending).toFixed(2));
            ErrorAlert("", "El valor ingresado supera el valor pendiente", "warning")
        } else {
            let title = 'Cargando....'
            let message = 'Cargando información....<br/> <br/>'
            let namePayment = paymentInfo.payment
            //-----------------------------------------------------
            //setBotonDeshabilitado(true);

            if (isKinposPaymentMethod(paymentInfo)) {
                await requestKinposPayment();
                return;
            }

            setShowModalProcess(true);
            setShowModalAmount(false)

            if (namePayment != "") {

                /*if (namePayment == 'PCCCOIN') {
                    setPaymentApproval({ status: 1, description: "APROBADO" });
                    let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                    setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2) }]);
                    setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                    setAmountPaymenReady(newAmountReady)


                    setTimeout(() => {
                        setAmountPayment(0)
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." })

                    }, 3000);

                } else */if (namePayment == 'Efectivo' || namePayment == 'PCCCOIN') {
                    title = 'Esperando aprobacion....'
                    message = 'El administrador esta aprobando el pago....<br/> <br/>'
                    //LoadingAlert(title, message)
                    //createOrderCash("Efectivo")

                    //show cash modal
                    setDetailOrder({ total: parseFloat(amountPayment), code: "0000" })
                    handleShowModal();
                } else if (namePayment == 'Yappy') {
                    setShowModalPhone(true)
                    //setChange(0);
                } else if (namePayment == 'Yappy QR') {

                    GenerateYappyTransaction()
                } else if (namePayment == 'Credito') {
                    aprovedManualPaymentacardMixto("Aprobado", "Pago con credito")
                } else {

                    if (paymentInfo.integration.id == 1) {
                        console.log("integracion con bac")
                        requestPyament();
                    } else if (paymentInfo.integration.id == 3) {
                        console.log("metodo de pago manual")
                        setPaymentManual(true)
                        setShowModalProcess(false);
                    }

                    //setChange(0);
                }

                setTimeout(() => {
                    setTempMethodPayment(1);
                }, 15000);
            } else {
                ErrorAlert("No hay metodo de pago.", "Selecciona un metodo de pago", "info");
                //setBotonDeshabilitado(false)
            }
        }
    }

    //genrate yappy transaction
    const GenerateYappyTransaction = async () => {
        if (statePayment == false) {
            setStatePayment(true)
            LoadingAlert()
            let token = localStorage.getItem('x-access-machine-token');
            let machine = JSON.parse(localStorage.getItem('machine'));
            let data = {
                "machine_id": machine.id,
                "total": decimalReduction(parseFloat(amountPayment)).toString(),
                "subtotal": decimalReduction(parseFloat(amountPayment)).toString(),
                "tax": "0",
                "discount": "0",
                "transaction_code": orderNumber,
                "description": "Smartpay - orden:" + orderNumber,
                "params": paymentInfo.params
            }
            try {
                const response = await YappyFetchAPI.newYappyQr(data, token)
                setStatePayment(false)
                ErrorAlert("", "Todo listo para que realices el pago", "info")
                setDataYappy(response.data);
                setYappy_transaction_id(response.data.yappy_transaction.body.transactionId)
                setDataHash(response.data.yappy_transaction.body.hash)
                setModalYappyQr(true)
                setStatusRequestYappy(true)
                //getYappyTransaction(response.data)

            } catch (err) {
                setStatePayment(false)
                showApiError(err, {
                    title: "Yappy no esta disponible",
                    message: "No se pudo generar la transaccion Yappy.",
                    context: `order=${orderNumber} amount=${amountPayment}`,
                    icon: "warning",
                }, ErrorAlert)
            }
        } else {
            console.log("peticion en proceso");
        }
    }

    //create order cash temporal
    let type = 0
    const createOrderCash = async (type_method) => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'))
        type = 0
        let json = {
            "client_name": "Estimado cliente",
            "localizador": "",
            "client_phone": "",
            "dgi_qr": "",
            "Orden": shoppingCart,
            "Descuento": 0.00,
            "Total": amountPayment,
            "itbms": 0.00,
            "subtotal": amountPayment,
            "machine_id": machine.id,
            "branchoffice_id": branchoffice.id,
            "tipoOrden": "comer aqui",
            "paymethod": paymentInfo.id,
            "is_discount_notification": false,
            "type_method": type_method,
            "transaction_code": orderNumber
        }

        try {
            const response = await CashTempPosFetchAPI.createTempCash(json, token)

            if (type_method == "Yappy") {
                console.log(response.data.newTempOrder._id);
                requestPyament(response.data.newTempOrder.code);
                setOrderNumberTemp({ code: response.data.newTempOrder.code, temp_id: response.data.newTempOrder._id })
            }

            console.log(response);
            getOrdersTempCash();
        } catch (err) {
            showApiError(err, {
                title: "No se pudo crear la orden temporal",
                message: "Se intentara recuperar una orden temporal existente.",
                context: `order=${orderNumber} payment=${type_method} amount=${amountPayment}`,
                icon: "warning",
            }, ErrorAlert)
            type = 1
            console.log("Hay una temporal");
            getOrdersTempCash();
        }
    }


    //get order temp cash
    let countGetCash = 0 // count to limit get orders
    const getOrdersTempCash = async () => {

        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'))
        let business = JSON.parse(localStorage.getItem('business'))
        clearInterval(instervalCash)
        try {
            const response = await CashTempPosFetchAPI.getTempCash(machine.code, business.code, branchoffice.code)
            console.log(response);
            let code = response.data.order.code
            let message = ""
            let title = ""
            let icon = ""

            if (type == 0) {
                if (countGetCash == 0) {
                    if (paymentInfo.payment != "Yappy") {
                        handleShowModal();
                    }
                    setDetailOrder(response.data.order);
                }

                if (response.data.order.status_id == 1) {
                    if (countGetCash <= 100) {
                        instervalCash = setInterval(getOrdersTempCash, 5000)
                        countGetCash++
                    } else {
                        message = "Tiempo de espera agotado"
                        title = "Advertencia"
                        icon = "warning"

                        if (paymentInfo.payment == "Yappy") {
                            ventanaYappy.close();
                            setPaymentApproval({ status: 3, description: "Tiempo de espera agotado." });
                        }
                        handleCloseModal()
                        updateOrderDiscount(code, 5, message, title, icon)
                        countGetCash = 0
                    }

                    //!Fixed Eroor: Correjir mensjae y  poner loading 
                } else if (response.data.order.status_id == 8) {//order temporal is cancel

                    title = "Operacion cancelada"
                    message = "Orden temporal cancelada"
                    icon = "error"

                    //setBotonDeshabilitado(false);

                    if (paymentInfo.payment == "Yappy") {
                        ventanaYappy.close();
                        setPaymentApproval({ status: 3, description: "Ocurrio un error." });
                    }
                    updateOrderDiscount(code, 5, message, title, icon)


                } else if (response.data.order.status_id == 7) {//order temporal is confirm
                    message = "El pago fue aprobado."
                    title = "Pago exitoso"
                    icon = "success"

                    if (paymentInfo.payment == "Yappy") {
                        ventanaYappy.close();
                        setPaymentApproval({ status: 1, description: "Pago exitoso." });
                    }

                    if (paymentInfo.payment == "Efectivo") {
                        //setShow(false)
                    }
                    updateOrderDiscount(code, 3, message, title, icon)

                    let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                    let statusPaymentTurn = false;
                    /*for (let i = 0; i < listPaymentReady.length; i++) {
                        if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                            let newTotal = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                            listPaymentReady[i].total = newTotal.toFixed(2)
                            setlistPaymentReady(listPaymentReady)
                            statusPaymentTurn = true
                        }
                    }*/

                    if (statusPaymentTurn == false) {
                        localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }] }))
                        setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }]);
                    }

                    console.log(newAmountReady);
                    setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                    setAmountPaymenReady(newAmountReady)

                    setTimeout(() => {
                        setAmountPayment(0)
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." })

                    }, 1500);

                }
            } else if (type == 1) {
                console.log("Consulte la temporal remanante");
                updateOrderDiscount(code, 5, message, title, icon)
            }
        } catch (err) {
            console.log(err);
        }
    }

    //update orders temporal discount
    const updateOrderDiscount = async (code, status, message, title, icon) => {
        console.log(code);
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))

        let jsonUpdate = {
            "order_code": code,
            "business_code": business.code,
            "branchoffice_code": branchoffice.code,
            "status": status
        }
        try {
            const response = await CashTempPosFetchAPI.updateOrderTempCash(jsonUpdate)
            console.log(paymentInfo.payment);

            if (type == 0) {
                if (paymentInfo.payment == "Yappy") {
                    setTimeout(() => {
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." });
                    }, 3000);
                }


                ErrorAlert(message, title, icon)


            } else if (type == 1) {
                console.log("Solicite crear nuevamente la temporal");
                createOrderCash(paymentInfo.payment)
            }
        } catch (err) {
            console.log(err);
        }

    }


    //function action request pyment local
    const requestPyament = async (yappy_Temp_id) => {
        setShowModalProcess(true);
        let JsonTr = {}

        if (paymentInfo.payment == "Yappy") {
            JsonTr = [{
                Tipo: 'SALE',
                Producto: 'COBRAR',
                Itbms: tax.toFixed(2),
                Descuento: discount.toFixed(2),
                Monto: parseFloat(amountPayment).toFixed(2),
                TipoVenta: paymentInfo.payment.toUpperCase(),
                paymentMethod: paymentInfo,
                orderid: yappy_Temp_id,
                tel: "507" + phoneClientYappy,
                total: parseFloat(amountPayment).toFixed(2),
                subtotal: parseFloat(amountPayment).toFixed(2),
                taxes: 0.00,
            }];
        } else {

            let methodPayment = ""
            if (paymentInfo.payment == "MasterCard") {
                methodPayment = "MC"
            } else {
                methodPayment = paymentInfo.payment
            }

            JsonTr = [{
                Tipo: 'SALE',
                Producto: 'COBRAR',
                Itbms: 0.00,
                Descuento: 0.00,
                Monto: parseFloat(amountPayment).toFixed(2),
                TipoVenta: methodPayment.toUpperCase(),
                paymentMethod: paymentInfo,
                orderid: orderNumber,
            }];

            let newToken = generateToken()
            JsonTr[0].SmartpayId = newToken
        }

        try {
            let machine = JSON.parse(localStorage.getItem('machine'))
            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
            const response = await RequestLocalFetchAPI.postPaymentMethod(JsonTr, response_machine.data.data.windows_ip);

            //setEMVStreamResponseMixto(response.data.data.EMVStreamResponse)

            const voucherMixto = saveMixtoVoucher(EMVStreamResponseMixto, response.data.data.EMVStreamResponse);
            setEMVStreamResponseMixto(voucherMixto);

            let responseCode = response.data.data.EMVStreamResponse.responseCode;
            let description = response.data.data.EMVStreamResponse.responseCodeDescription;



            function successPayment() {
                setPaymentApproval({ status: 1, description: description });
                let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                let statusPaymentTurn = false;
                /*for (let i = 0; i < listPaymentReady.length; i++) {
                    if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                        listPaymentReady[i].total = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                        setlistPaymentReady(listPaymentReady)
                        statusPaymentTurn = true
                    }
                }*/

                if (statusPaymentTurn == false) {
                    // Respuesta cruda del datafono para ESTA pierna - necesaria para poder reversarla
                    // individualmente por su gateway si esta orden Mixta se devuelve completa.
                    const legVoucherResponse = JSON.stringify(response.data.data.EMVStreamResponse);
                    localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }] }))
                    setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }]);
                }

                setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                setAmountPaymenReady(newAmountReady)
            }

            //condition
            console.log(response)
            if (paymentInfo.payment != "Yappy") {

                if (responseCode == "00") {
                    successPayment()
                } else {
                    setPaymentApproval({ status: 2, description: description });

                }

            } else {

                if (responseCode == "20") {
                    successPayment()
                } else {
                    setPaymentApproval({ status: 2, description: description });
                }

                {/*condition yappy temp
                if (response.data.data == "") {
                    setPaymentApproval({ status: 3, description: "Ocurrio un error." });

                } else {
                    ventanaYappy = window.open(response.data.data, "test", "");
                }*/}

            }

            setTimeout(() => {
                setAmountPayment(0)
                setShowModalProcess(false);
                setPaymentApproval({ status: 0, description: "Procesando pago..." })

            }, 3000);

        } catch (err) {
            setAmountPayment(0)
            const apiError = normalizeApiError(err, {
                title: "No se pudo procesar el pago mixto",
                message: "El metodo de pago no respondio correctamente.",
                context: `order=${orderNumber} payment=${paymentInfo.payment} amount=${amountPayment}`,
            });

            setPaymentApproval({ status: 3, description: apiError.message });
            showApiError(err, {
                title: apiError.title,
                message: apiError.message,
                context: `order=${orderNumber} payment=${paymentInfo.payment} amount=${amountPayment}`,
            }, ErrorAlert)

        }
    }

    //register payment aproved manual
    const aprovedManualPaymentacardMixto = (
        description,
        reference,
        paymentOverride = paymentInfo,
        amountOverride = amountPayment,
        kinposRequestId,
        voucherResponse
    ) => {
        const storedPaymentState = safeJsonParse(localStorage.getItem('mixto_payment_approved'));
        if (
            kinposRequestId
            && storedPaymentState?.payments?.some((payment) => payment.kinpos_request_id === kinposRequestId)
        ) {
            setlistPaymentReady(storedPaymentState.payments);
            setAmountPaymenReady(Number(storedPaymentState.amountPaymentReady));
            setAmountPending(Number(storedPaymentState.amountPending));
            setShowModalProcess(false);
            return false;
        }

        const voucherMixto = saveMixtoVoucher(EMVStreamResponseMixto, reference);
        setEMVStreamResponseMixto(voucherMixto);

        setPaymentApproval({ status: 1, description: description });
        const approvedAmount = Number(parseFloat(amountOverride).toFixed(2));
        const newAmountReady = Number((approvedAmount + Number(amountPaymentReady)).toFixed(2));
        const newAmountPending = Number((Number(total) - newAmountReady).toFixed(2));
        const paymentMethodId = getPaymentMethodId(paymentOverride);
        const paymentEntry = {
            name: paymentOverride.payment,
            paymethod_id: paymentMethodId,
            total: approvedAmount.toFixed(2),
            paymenthod_integration_id: getPaymentIntegrationId(paymentOverride),
            // Respuesta cruda del gateway de ESTA pierna - necesaria para poder reversarla
            // individualmente por su gateway si esta orden Mixta se devuelve completa.
            voucher_response: voucherResponse ? JSON.stringify(voucherResponse) : 0,
            ...(kinposRequestId ? { kinpos_request_id: kinposRequestId } : {}),
        };
        let statusPaymentTurn = false;
        /*for (let i = 0; i < listPaymentReady.length; i++) {
            if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                listPaymentReady[i].total = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                setlistPaymentReady(listPaymentReady)
                statusPaymentTurn = true
            }
        }*/

        if (statusPaymentTurn == false) {
            const payments = [...listPaymentReady, paymentEntry];
            localStorage.setItem('mixto_payment_approved', JSON.stringify({
                amountPaymentReady: newAmountReady,
                amountPending: newAmountPending,
                payments,
            }))
            setlistPaymentReady(payments);
        }

        setAmountPending(newAmountPending)
        setAmountPaymenReady(newAmountReady)


        //---------------------------------------------------------------------------------
        setAmountPayment(0)
        setShowModalProcess(false);
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
        return true;

    }

    const handleKinposResult = async (result) => {
        if (result.status === "pending") {
            setKinposPaymentPending(true);
            return;
        }

        if (result.status === "uncertain") {
            setKinposPaymentPending(true);
            setShowModalProcess(false);
            setPaymentApproval({ status: 0, description: "Resultado KinPOS pendiente de confirmacion" });
            showKinposFailure(result);
            return;
        }

        if (result.status !== "approved") {
            setPaymentApproval({ status: 2, description: result.message || "Pago no aprobado" });
            setShowModalProcess(false);
            showKinposFailure(result);
            kinposPaymentBridge.complete(result.request_id);
            setKinposPaymentPending(false);
            return;
        }

        const selectedPayment = findKinposPaymentMethodById(
            paymentMethod,
            result.request.payment_method_id
        ) || (isKinposPaymentMethod(paymentInfo) ? paymentInfo : null);

        if (!selectedPayment) {
            kinposPaymentBridge.markProcessingFailed(result.request_id);
            setShowModalProcess(false);
            ErrorAlert(
                "KinPOS aprobo el cobro, pero el metodo de pago ya no esta disponible en esta maquina. No vuelvas a cobrar.",
                "Pago cobrado pendiente de registro",
                "warning"
            );
            return;
        }

        const actualPayment = resolveActualKinposPaymentMethod(
            selectedPayment,
            result.transaction?.card_network,
            paymentMethod
        );
        const selectedPaymentId = getPaymentMethodId(selectedPayment);
        const actualPaymentId = getPaymentMethodId(actualPayment);
        const networkPaymentId = getKnownKinposCardNetworkPaymentMethodId(
            result.transaction?.card_network
        );
        if (networkPaymentId !== null && selectedPaymentId !== networkPaymentId) {
            console.warn("KinPOS card network differs from the selected mixed payment method", {
                request_id: result.request_id,
                selected_payment_method_id: selectedPaymentId,
                resolved_payment_method_id: actualPaymentId,
                card_network: result.transaction.card_network,
            });
        }

        const paymentRecord = {
            ...toKinposPaymentRecord(result),
            payment_method_id: actualPaymentId,
        };
        aprovedManualPaymentacardMixto(
            "APROBADO",
            paymentRecord.voucher,
            actualPayment,
            result.request.amount.total,
            result.request_id,
            { transaction: paymentRecord.transaction, request_id: paymentRecord.request_id, order_reference: paymentRecord.order_reference }
        );
        kinposPaymentBridge.markAwaitingRegistration(result.request_id);
        setKinposPaymentPending(false);
    };

    kinposResultHandlerRef.current = handleKinposResult;

    useEffect(() => {
        if (!paymentMethod.length) return undefined;
        return kinposPaymentBridge.subscribe(
            "mixed",
            (result) => kinposResultHandlerRef.current?.(result)
        );
    }, [paymentMethod.length]);

    useEffect(() => kinposPaymentBridge.subscribePendingState((pendingPayment) => {
        setKinposPaymentPending(
            pendingPayment?.mode === "mixed"
            && pendingPayment.state !== "awaiting_registration"
        );
    }), []);

    useEffect(() => {
        const pendingPayment = kinposPaymentBridge.getPendingPayment();
        if (pendingPayment?.mode !== "mixed") return;

        const storedPaymentState = safeJsonParse(localStorage.getItem('mixto_payment_approved'));
        if (storedPaymentState?.payments) {
            setlistPaymentReady(storedPaymentState.payments);
            setAmountPaymenReady(Number(storedPaymentState.amountPaymentReady));
            setAmountPending(Number(storedPaymentState.amountPending));
            setEMVStreamResponseMixto({ voucher: getStoredMixtoVoucher() });
        }

        if (!paymentMethod.length) return;
        if (pendingPayment.state === "awaiting_registration") {
            setKinposPaymentPending(false);
            return;
        }

        setKinposPaymentPending(true);
        Promise.resolve(kinposPaymentBridge.recover()).finally(() => {
            const currentPendingPayment = kinposPaymentBridge.getPendingPayment();
            setKinposPaymentPending(currentPendingPayment?.mode === "mixed");
        });
    }, [paymentMethod, setAmountPaymenReady, setAmountPending, setlistPaymentReady]);

    //cancel temporal transaction yappy
    const cancelTempYappy = () => {
        let message = "Orden temporal cancelada"
        let title = "Operacion cancelada"
        let icon = "error"
        updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
    }

    //cancel method payment in process
    const cancelMethodPayment = () => {
        setTempMethodPayment(0);
        setPaymentApproval({ status: 0, description: "Procesando pago..." })

        setShowModalProcess(false);
        {/*if (paymentInfo.payment == "Yappy") {
            let message = "Orden temporal cancelada"
            let title = "Operacion cancelada"
            let icon = "error"
            updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
        } else {
            setShowModalProcess(false);
        }*/}
    }

    //function try again yappy
    const try_again_yappy = () => {
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
        requestPyament(orderNumbeTemp.temp_id);
    }


    //function action select payment
    const handlerPaymentStatus = () => {
        if (paymentInfo.payment != "") {

            if (paymentInfo.payment == "Efectivo" || paymentInfo.payment == "PCCCOIN") {

                //show cash modal
                setDetailOrder({ total: parseFloat(amountPayment), code: "0000" })
                handleShowModal();
            } else {
                setShowModalAmount(true)
            }

        } else {
            ErrorAlert("No hay metodo de pago.", "Selecciona un metodo de pago", "info");
        }
    }

    const hadleCancelYappy = (text) => {

        if (text != undefined) {
            setPaymentApproval({ status: 2, description: text });
        } else {
            setPaymentApproval({ status: 2, description: "CANCELADO" });
        }

        setYappy_transaction_id("")
        setModalYappyQr(false);
        setStatusRequestYappy(false)
        setAmountPayment(0)

        setTimeout(() => {
            setShowModalProcess(false);
            setPaymentInfo({ payment: "", payment_id: 0 })

            setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
    }

    const getYappyTransaction = async () => {
        let token = localStorage.getItem('x-access-machine-token');

        try {
            let yappy_transaction_id = dataYappy.yappy_transaction.body.transactionId

            const response = await YappyFetchAPI.getYappyTransaction(yappy_transaction_id, token);

            let status = response.data.yappy_transaction.body.status;

            switch (status) {
                case 'PENDING':
                    //console.log("Transaccion pendiente");
                    break;

                case 'COMPLETED':
                    //console.log("Transaccion aprobada");

                    setModalYappyQr(false)
                    setStatusRequestYappy(false)
                    setPaymentApproval({ status: 1, description: "APROBADO" })

                    setTimeout(() => {

                        let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                        let statusPaymentTurn = false;
                        /*for (let i = 0; i < listPaymentReady.length; i++) {
                            if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                                listPaymentReady[i].total = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                                setlistPaymentReady(listPaymentReady)
                                statusPaymentTurn = true
                            }
                        }*/

                        if (statusPaymentTurn == false) {
                            // yappy_transaction_id de ESTA pierna - necesario para poder reversarla
                            // individualmente si esta orden Mixta se devuelve completa.
                            const legVoucherResponse = JSON.stringify({ yappy_transaction_id });
                            localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }] }))
                            setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }]);
                        }

                        setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                        setAmountPaymenReady(newAmountReady)
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." })
                        setAmountPayment(0)
                    }, 3000);

                    break;

                case 'DECLINED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("")
                    setYappy_transaction_id("")
                    hadleCancelYappy('DECLINED')

                    break;

                case 'EXPIRED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("");
                    setYappy_transaction_id("")
                    hadleCancelYappy('EXPIRED')
                    break;

                case 'FAILED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("")
                    setYappy_transaction_id("")
                    hadleCancelYappy('FAILED')
                    break;

                case 'VOIDED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("")
                    setYappy_transaction_id("")
                    hadleCancelYappy('VOIDED')
                    break;

            }

        } catch (err) {
            console.log(err);
            setPaymentInfo({ payment: "" })
            setDataHash("")
            setYappy_transaction_id("")
            hadleCancelYappy("ERROR DE CONSULTA")
        }

    }


    useEffect(() => {
        let timer = 0
        if (statusRequestYappy == true) {
            timer = setInterval(async () => getYappyTransaction(), 5000); //INTERVAL GET YAPPY STATUS TRANSACTION

            return () => clearInterval(timer)
        } else {
            return () => clearInterval(timer) //CLEAR INTERVAL
        }

    }, [statusRequestYappy, dataYappy]);

    useEffect(() => {
        if (showModalMixto == true) {
            let mixto_payment_approved = safeJsonParse(localStorage.getItem('mixto_payment_approved'));
            if (mixto_payment_approved && Array.isArray(mixto_payment_approved.payments)) {
                setlistPaymentReady(mixto_payment_approved.payments);
                setEMVStreamResponseMixto({ voucher: getStoredMixtoVoucher() });

                let newAmountReady = 0;
                mixto_payment_approved.payments.forEach((payment) => {
                    newAmountReady += parseFloat(payment.total);
                });

                setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                setAmountPaymenReady(newAmountReady)

                setTimeout(() => {
                    setAmountPayment(0)
                    setShowModalProcess(false);
                    setPaymentApproval({ status: 0, description: "Procesando pago..." })

                }, 3000);
            }
        }

    }, [showModalMixto]);

    // ---- Pago mixto ATRAPADO en este dispositivo ----
    // Un pago mixto aprobado (ej. una tarjeta KinPOS) se conserva en el telefono hasta que la orden se registre, y al
    // abrir la app se restaura SIEMPRE esta pantalla. Si la orden nunca se pudo completar (la cuenta cambio y el saldo
    // quedo negativo, el carrito ya no existe...), "Finalizar" exige saldo 0 y "Realizar pago" saldo mayor a 0: con saldo
    // negativo no habia NINGUN boton y el dispositivo se quedaba en esta pantalla para siempre. Esta es la salida: solo
    // se ofrece cuando el pago esta realmente atrapado (saldo negativo, o pendiente viejo que ya no esta en curso) y
    // pide confirmacion explicita + deja constancia local de lo que se descarto.
    const STALE_MIXED_PENDING_MS = 30 * 60 * 1000;
    const pendingMixedKinpos = (() => {
        const pending = kinposPaymentBridge.getPendingPayment();
        return pending?.mode === "mixed" ? pending : null;
    })();
    const mixedIsOverpaid = Number(amountPending) < -0.004;
    const mixedPendingIsStale = Boolean(pendingMixedKinpos)
        && pendingMixedKinpos.state !== "pending"
        && (Date.now() - Number(pendingMixedKinpos.created_at || 0)) > STALE_MIXED_PENDING_MS;
    const mixedChargeInFlight = Boolean(pendingMixedKinpos) && pendingMixedKinpos.state === "pending";
    const canDiscardStuckPayment = !mixedChargeInFlight && (mixedIsOverpaid || mixedPendingIsStale);

    const escapeHtml = (value) => String(value ?? "")
        .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

    const discardStuckMixedPayment = async () => {
        const paymentsSummary = listPaymentReady.length > 0
            ? listPaymentReady.map((payment) => `${escapeHtml(payment.name)}: $${Number(payment.total || 0).toFixed(2)}`).join("<br/>")
            : "Sin pagos aplicados";
        const hasCardPayment = Boolean(pendingMixedKinpos)
            || listPaymentReady.some((payment) => payment.kinpos_request_id || Number(payment.paymenthod_integration_id) === 10);
        const createdAt = pendingMixedKinpos?.created_at ? new Date(Number(pendingMixedKinpos.created_at)).toLocaleString() : null;

        const confirmation = await Swal.fire({
            icon: "warning",
            title: "Descartar pago mixto pendiente",
            html: `<div style="text-align:left;font-size:14px;line-height:1.5">
                <p><strong>Pagos aplicados:</strong><br/>${paymentsSummary}</p>
                <p><strong>Saldo:</strong> $${Number(amountPending).toFixed(2)}${createdAt ? `<br/><strong>Pendiente desde:</strong> ${escapeHtml(createdAt)}` : ""}</p>
                <p style="color:#b42318">${hasCardPayment
                    ? "Este pago incluye una tarjeta cobrada en el terminal. Descartarlo NO la reversa ni registra la orden: confirma que ya fue registrada, devuelta o conciliada antes de continuar."
                    : "Se borrarán los pagos aplicados de esta pantalla; no se registrará ninguna orden."}</p>
            </div>`,
            showCancelButton: true,
            confirmButtonText: "Sí, descartar",
            cancelButtonText: "Cancelar",
            focusCancel: true,
            allowOutsideClick: false,
        });
        if (!confirmation.isConfirmed) return;

        // Constancia local (ultimos 20): que se descarto, cuando y por quien.
        try {
            const user = safeJsonParse(localStorage.getItem("user"), null);
            const history = safeJsonParse(localStorage.getItem("smartpay.kinpos.discarded.v1"), []);
            history.push({
                discarded_at: new Date().toISOString(),
                discarded_by: user?.name || user?.user_name || user?.id || null,
                request_id: pendingMixedKinpos?.request_id || null,
                order_reference: pendingMixedKinpos?.order_reference || null,
                pending_state: pendingMixedKinpos?.state || null,
                pending_created_at: pendingMixedKinpos?.created_at || null,
                amount_pending: Number(amountPending),
                payments: listPaymentReady.map((payment) => ({ name: payment.name, total: payment.total, integration: payment.paymenthod_integration_id, kinpos_request_id: payment.kinpos_request_id || null })),
            });
            localStorage.setItem("smartpay.kinpos.discarded.v1", JSON.stringify(history.slice(-20)));
        } catch (error) {
            // La constancia es mejor esfuerzo: no debe impedir liberar el dispositivo.
        }

        if (pendingMixedKinpos?.request_id) {
            kinposPaymentBridge.discardPendingPayment(pendingMixedKinpos.request_id);
        }
        localStorage.removeItem("mixto_payment_approved");
        localStorage.removeItem("voucher_mixto");
        setlistPaymentReady([]);
        setAmountPaymenReady(0);
        setAmountPending(Number(total));
        setEMVStreamResponseMixto({ voucher: getStoredMixtoVoucher() });
        setKinposPaymentPending(false);
        setShowModalMixto(false);
        SuccessAlert("Pago pendiente descartado.");
    };

    const finalizeMixedPayment = async () => {
        const pendingKinposPayment = kinposPaymentBridge.getPendingPayment();
        if (pendingKinposPayment?.mode !== "mixed") {
            formatDataOrder(EMVStreamResponseMixto, true);
            setShowModalMixto(false);
            return;
        }

        setKinposPaymentPending(true);
        const registration = await formatDataOrder(EMVStreamResponseMixto, true);
        if (registration?.success === true) {
            const currentPendingPayment = kinposPaymentBridge.getPendingPayment();
            if (currentPendingPayment?.mode === "mixed") {
                kinposPaymentBridge.complete(currentPendingPayment.request_id);
            }
            setKinposPaymentPending(false);
            setShowModalMixto(false);
            return;
        }

        setKinposPaymentPending(false);
        ErrorAlert(
            "La orden no pudo registrarse. Los pagos aprobados se conservaron; no vuelvas a cobrar las tarjetas KinPOS.",
            "Pago mixto pendiente de registro",
            "warning"
        );
    }


    return (
        <>

            {showModalMixto && createPortal(
                <div className="mix-overlay" role="dialog" aria-modal="true" aria-label="Pago mixto">
                    <div className="mix-dialog">

                        {/* ---------------- HEADER ---------------- */}
                        <header className="mix-head">
                            <i className="uil uil-money-bill" />
                            <h2 className="mix-title">Pago mixto</h2>
                            <span className="mix-head-pending">
                                Pendiente <strong translate="no">${(amountPending).toFixed(2)}</strong>
                            </span>
                        </header>

                        {/* ---------------- BODY ---------------- */}
                        <div className="mix-body">
                            <div className="mix-grid">

                                {/* ===== MÉTODOS ===== */}
                                <section className="mix-card">
                                    <h3 className="mix-card-title">Seleccione un método de pago</h3>

                                    {!paymentMethod.length ? (
                                        <Empty title="Vacío" msg="No hay métodos de pago asignados" img={empty_img} />
                                    ) : (
                                        <PayScroller>
                                            {paymentMethod.map(option => (
                                                option.payment != "Mixto" ? (
                                                    <article className="pay-mdl-method" key={option.id}>
                                                        <input
                                                            type="radio"
                                                            className="pay-mdl-method-input"
                                                            disabled={kinposPaymentPending}
                                                            name="option_payments"
                                                            id={option.id + "" + option.integration_id + "paymentMixto"}
                                                            value={JSON.stringify(option)}
                                                            onChange={(e) => (selectPayment(e))}
                                                        />
                                                        <label
                                                            className="pay-mdl-method-card"
                                                            htmlFor={option.id + "" + option.integration_id + "paymentMixto"}
                                                        >
                                                            <span className="pay-mdl-method-check" aria-hidden="true" />
                                                            <img
                                                                loading="lazy"
                                                                className="pay-mdl-method-logo"
                                                                src={buildCloudinaryImageUrl({ url: option.img, width: 300, quality: "auto", type: "image" }) || empty_img}
                                                                alt=""
                                                            />
                                                            <span className="pay-mdl-method-name">{option.payment}</span>
                                                            <span className="pay-mdl-method-tag">{option.integration.name}</span>
                                                        </label>
                                                    </article>

                                                ) : null
                                            ))}
                                        </PayScroller>
                                    )}
                                </section>

                                {/* ===== CUENTA E HISTORIAL ===== */}
                                <section className="mix-card">
                                    <h3 className="mix-card-title">Detalle de la cuenta</h3>

                                    <div className="mix-line">
                                        <span>Total con impuesto</span>
                                        <span className="mix-line-val" translate="no">${total.toFixed(2)}</span>
                                    </div>

                                    <div className="mix-history-head">
                                        <span className="mix-history-label">Pagos aplicados</span>
                                        <span className="mix-count">{listPaymentReady.length}</span>
                                    </div>

                                    {listPaymentReady.length === 0 ? (
                                        <p className="mix-empty">Aún no se ha aplicado ningún pago.</p>
                                    ) : (
                                        <ul className="mix-history">
                                            {listPaymentReady.map((payment, idx) => (
                                                <li className="mix-history-item" key={idx}>
                                                    <span className="mix-history-index">{idx + 1}</span>
                                                    <span className="mix-history-name">{payment.name}</span>
                                                    <span className="mix-history-val" translate="no">
                                                        ${parseFloat(payment.total).toFixed(2)}
                                                    </span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    <div className="mix-line mix-line--pending">
                                        <span>Saldo pendiente</span>
                                        <span className="mix-line-val" translate="no">${(amountPending).toFixed(2)}</span>
                                    </div>
                                </section>

                            </div>
                        </div>

                        {/* ---------------- FOOTER ---------------- */}
                        <div className="mix-foot">
                            <div className="mix-foot-total">
                                <span className="mix-foot-label">Saldo pendiente</span>
                                <span className="mix-foot-amount" translate="no">${(amountPending).toFixed(2)}</span>
                            </div>

                            <div className="mix-foot-actions">
                                <RenderIf isTrue={parseFloat(amountPending).toFixed(2) == 0.00}>
                                    <button
                                        className="mix-btn mix-btn--finish"
                                        disabled={kinposPaymentPending}
                                        onClick={finalizeMixedPayment}
                                    >
                                        Finalizar pago
                                    </button>
                                </RenderIf>

                                <RenderIf isTrue={parseFloat(amountPending).toFixed(2) > 0.00}>
                                    {listPaymentReady.length > 0 ? <></> : (
                                        <button
                                            className="mix-btn mix-btn--ghost"
                                            disabled={kinposPaymentPending}
                                            onClick={() => setShowModalMixto(false)}
                                        >
                                            Cancelar
                                        </button>
                                    )}

                                    <button
                                        className="mix-btn mix-btn--pay"
                                        disabled={kinposPaymentPending}
                                        onClick={() => handlerPaymentStatus()}
                                    >
                                        {kinposPaymentPending ? "Procesando en KinPOS..." : "Realizar pago"}
                                    </button>
                                </RenderIf>

                                <RenderIf isTrue={canDiscardStuckPayment}>
                                    <button
                                        className="mix-btn mix-btn--ghost"
                                        style={{ color: "#b42318", borderColor: "#fda29b" }}
                                        onClick={discardStuckMixedPayment}
                                    >
                                        Descartar pago pendiente
                                    </button>
                                </RenderIf>
                            </div>
                        </div>

                    </div>
                </div>,
                document.body
            )}
            {showModalAmount && createPortal(
                <div className="amt-overlay" role="dialog" aria-modal="true" aria-label="Ingrese un monto">
                    <div className="amt-dialog">

                        {/* ---------------- HEADER ---------------- */}
                        <header className="amt-head">
                            <i className="uil uil-dollar-alt" />
                            <h2 className="amt-title">Ingrese un monto</h2>
                            <span className="amt-method-chip">
                                Método: <strong>{paymentInfo.payment}</strong>
                            </span>
                        </header>

                        {/* ---------------- BODY ---------------- */}
                        <div className="amt-body">

                            <div className="amt-field">
                                <label className="amt-field-label" htmlFor="amt-input">Monto a aplicar</label>
                                <div className="amt-input-wrap">
                                    <span className="amt-input-prefix" aria-hidden="true">$</span>
                                    <input
                                        id="amt-input"
                                        type="number"
                                        className="amt-input"
                                        placeholder="0.00"
                                        inputMode="decimal"
                                        onChange={(e) => (setAmountPayment(e.target.value))}
                                    />
                                </div>
                            </div>

                            <section className="amt-card">
                                <h3 className="amt-card-title">Detalle</h3>

                                <div className="amt-line amt-line--pending">
                                    <span>Saldo pendiente</span>
                                    <span className="amt-line-val" translate="no">${(amountPending).toFixed(2)}</span>
                                </div>

                                <div className="amt-line amt-line--new">
                                    <span>Nuevo saldo</span>
                                    <span className="amt-line-val" translate="no">
                                        ${amountPayment != "" && amountPayment != null && amountPayment != undefined
                                            ? <>{(amountPending - amountPayment).toFixed(2)}</>
                                            : <>{amountPending.toFixed(2)}</>}
                                    </span>
                                </div>

                                <div className="amt-line amt-line--total">
                                    <span>Total a pagar</span>
                                    <span className="amt-line-val" translate="no">${total.toFixed(2)}</span>
                                </div>
                            </section>

                        </div>

                        {/* ---------------- FOOTER ---------------- */}
                        <div className="amt-foot">
                            <div className="amt-foot-actions">
                                <button
                                    className="amt-btn amt-btn--ghost"
                                    disabled={kinposPaymentPending}
                                    onClick={() => setShowModalAmount(false)}
                                >
                                    Cancelar
                                </button>

                                <button
                                    className="amt-btn amt-btn--apply"
                                    disabled={kinposPaymentPending}
                                    onClick={async () => (processPayment())}
                                >
                                    {kinposPaymentPending ? "Procesando..." : "Aplicar"}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>,
                document.body
            )}


            {/*Process payment Loading Modal */}
            {showModalProcess && createPortal(
                <div className="proc-overlay" role="dialog" aria-modal="true" aria-label="Procesando pago">
                    {/*  
      <header className="proc-head">
         <i className="uil uil-transaction" />
         <h2 className="proc-head-title">Pagos</h2>
      </header> */}

                    <main className="proc-main">
                        <section className="proc-card">

                            {/* ---------------- EN PROCESO ---------------- */}
                            <RenderIf isTrue={paymentApproval.status == 0}>
                                <span className="proc-method proc-method--wait">
                                    Método de pago: {paymentInfo.payment}
                                </span>

                                <img className="proc-icon" src={loading} width="256" height="256" alt="" />

                                <h3 className="proc-title">{paymentApproval.description}</h3>

                                {tempMethodPayment == 1 ? (
                                    <div className="proc-actions">
                                        <button className="proc-btn proc-btn--ghost" onClick={() => cancelMethodPayment()}>
                                            Cancelar
                                        </button>
                                    </div>
                                ) : ""}
                            </RenderIf>

                            {/* ---------------- ÉXITO ---------------- */}
                            <RenderIf isTrue={paymentApproval.status == 1}>
                                <span className="proc-method proc-method--ok">
                                    Método de pago: {paymentInfo.payment}
                                </span>

                                <img className="proc-icon" src={checkimg} width="96" height="96" alt="" />

                                <h3 className="proc-title">¡Éxito!</h3>
                                <p className="proc-text">Su pago ha sido procesado correctamente.</p>
                            </RenderIf>

                            {/* ---------------- ERROR ---------------- */}
                            <RenderIf isTrue={paymentApproval.status == 2}>
                                <span className="proc-method proc-method--bad">
                                    Método de pago: {paymentInfo.payment}
                                </span>

                                <img className="proc-icon" src={cancel} width="96" height="96" alt="" />

                                <h3 className="proc-title proc-title--sm">{paymentApproval.description}</h3>
                                <p className="proc-text">Verifique la información e intente nuevamente.</p>
                            </RenderIf>

                            {/* ---------------- ERROR CON REINTENTO ---------------- */}
                            <RenderIf isTrue={paymentApproval.status == 3}>
                                <span className="proc-method proc-method--bad">
                                    Método de pago: {paymentInfo.payment}
                                </span>

                                <img className="proc-icon" src={cancel} width="96" height="96" alt="" />

                                <h3 className="proc-title proc-title--sm">{paymentApproval.description}</h3>
                                <p className="proc-text">Verifique la información e intente nuevamente.</p>

                                <div className="proc-actions">
                                    {/* <button className="proc-btn proc-btn--ghost" onClick={() => (cancelTempYappy())}>
                                        Volver
                                    </button> */}
                                    <button className="proc-btn proc-btn--primary" onClick={() => (try_again_yappy())}>
                                        Intentar de nuevo
                                    </button>
                                </div>
                            </RenderIf>

                        </section>
                    </main>
                </div>,
                document.body
            )}


            {/*input phone client */}
            <ModalPhoneSaveYappy showModalPhone={showModalPhone} setShowModalPhone={setShowModalPhone} setPhoneClientYappy={setPhoneClientYappy} nextStepYappy={nextStepYappy}></ModalPhoneSaveYappy>


            {/* Modal cashier */}
            {modalShow && createPortal(
                <div className="cash-overlay" role="dialog" aria-modal="true" aria-label="Cajero">
                    <div className="cash-dialog">

                        {/* ---------------- HEADER ---------------- */}
                        <header className="cash-head">
                            <div className="cash-head-item">
                                <span className="cash-head-label">Orden</span>
                                <span className="cash-head-val">{!orderNumber ? "0000" : orderNumber}</span>
                            </div>

                            <div className="cash-head-item cash-head-item--due">
                                <span className="cash-head-label">Monto a pagar</span>
                                <span className="cash-head-val" translate="no">${amountPending.toFixed(2)}</span>
                            </div>

                            <button
                                type="button"
                                className="cash-close"
                                aria-label="Cerrar"
                                onClick={handleCloseModal}
                            >
                                <i className="uil uil-times" />
                            </button>
                        </header>

                        {/* ---------------- BODY + FOOTER ---------------- */}
                        <Cashierpost
                            setChange={setChange}
                            setAmountOrder={setAmountOrder}
                            setOrderNumber={setNumberOrderMixto}
                            setModalShow={setModalShow}
                            order_data={detailOrder}
                            statusCash={statusCash}
                            paymentInfo={paymentInfo}
                            mixto={true}
                            setAmountPayment={setAmountPayment}
                            amountPending={amountPending}
                            amountPayment={amountPayment}
                            total={total}
                        />

                    </div>
                </div>,
                document.body
            )}

            {/*Modal payment manual*/}
            <ModalPaymentManual showPaymentManual={showPaymentManual} setPaymentManual={setPaymentManual} paymentInfo={paymentInfo} registernewOrder={registernewOrder} statusActivity={false} aprovedManualPaymentacardMixto={aprovedManualPaymentacardMixto}></ModalPaymentManual>
            <ModalYappyQrPos modalYappyQr={modalYappyQr} setModalYappyQr={setModalYappyQr} dataYappy={dataYappy} setDataHash={setDataHash} setYappy_transaction_id={setYappy_transaction_id} dataHash={dataHash} hadleCancelYappy={hadleCancelYappy} total={parseFloat(amountPayment)} orderNumber={orderNumber} totaltopay={parseFloat(amountPayment)}></ModalYappyQrPos>




        </>
    )
}

export default ModalPaymentMixto
